var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossSolidRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.942,
    height: 25.942,
    viewBox: "0 0 25.942 25.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-13.1 -2.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(13.101 2.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M30.511,2.55a12.971,12.971,0,1,0,12.97,12.971A12.971,12.971,0,0,0,30.511,2.55Zm4.784,15.814a1.218,1.218,0,1,1-1.723,1.722l-3-3-3.02,3.02a1.218,1.218,0,1,1-1.722-1.722l3.02-3.02-3.1-3.1a1.218,1.218,0,1,1,1.72-1.724l3.1,3.1,3.092-3.092a1.218,1.218,0,0,1,1.722,1.722l-3.084,3.1Z",
    transform: "translate(-17.54 -2.55)",
    fill: "#e6231f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSolidRed);
export default __webpack_public_path__ + "static/media/cross-solid-red.a8a4c3a6c94b62af81874fee5c40aea5.svg";
export { ForwardRef as ReactComponent };